import React from "react";

import svg from "../../assets/images/icons/var.svg";

export const VariableIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Variable"}
    />
);
